import ReportsSerializer from './base';

export default class RubricFamily extends ReportsSerializer {
  normalize(typeClass, hash, prop) {
    // Go's `omitempty` leaves out false and empty values, which ember-data
    // reads as unchanged. Fill them in, so a family that is no longer the
    // default (the API clears the old one when another takes over) stops
    // showing as default after a reload.
    hash = { isDefault: false, description: '', ...hash };
    return super.normalize(typeClass, hash, prop);
  }
}
